import { Moon, Settings as SettingsIcon, Sun } from 'lucide-react'
import { useTheme } from '../useTheme'
import { PageHeader } from '../components/PageHeader'
import { DevControlPanel } from '../components/DevControlPanel'
import { Button } from '../components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card'

export function SettingsPage() {
  const { theme, toggle } = useTheme()

  return (
    <div className="flex flex-col gap-6">
      <PageHeader icon={SettingsIcon} title="Settings" description="Preferencias personales de esta cuenta." />

      <Card className="max-w-md">
        <CardHeader>
          <CardTitle className="text-base">Apariencia</CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">Tema {theme === 'dark' ? 'oscuro' : 'claro'}</p>
          <Button variant="outline" size="sm" onClick={toggle}>
            {theme === 'dark' ? <Sun className="size-4" /> : <Moon className="size-4" />}
            Cambiar a {theme === 'dark' ? 'claro' : 'oscuro'}
          </Button>
        </CardContent>
      </Card>

      {import.meta.env.DEV && <DevControlPanel />}
    </div>
  )
}
